{
  "username" : "Username",
  "password" : "Password",
  "email" : "E-mail",
  "title": "Sign up"
}